import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class DudaTemplateRepositoryService extends BaseRepositoryService<
  ModelRegistry['duda-template']
> {
  recordName = 'duda-template';
  implementMethods = ['findAll', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/duda-template': DudaTemplateRepositoryService;
  }
}
